import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useBrand } from '../contexts/BrandContext';

const SplashScreen = ({ onDone }) => {
  const { footerLogoUrl, footerLogoScale } = useBrand();
  const scaleRatio = (footerLogoScale || 100) / 100;

  useEffect(() => {
    const t = setTimeout(onDone, 2600);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center overflow-hidden select-none"
      style={{ background: 'linear-gradient(145deg, #0f0a1a 0%, #2d0070 55%, #4e00cc 100%)' }}
      initial={{ opacity: 1 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.55, ease: 'easeInOut' }}
    >
      {/* Bokeh — top right */}
      <motion.div
        className="absolute rounded-full pointer-events-none"
        style={{
          width: 340, height: 340,
          background: 'radial-gradient(circle, rgba(147,112,255,0.18), transparent 70%)',
          top: '-8%', right: '-12%',
        }}
        animate={{ scale: [1, 1.15, 1] }}
        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Bokeh — bottom left */}
      <motion.div
        className="absolute rounded-full pointer-events-none"
        style={{
          width: 260, height: 260,
          background: 'radial-gradient(circle, rgba(180,130,255,0.12), transparent 70%)',
          bottom: '10%', left: '-8%',
        }}
        animate={{ scale: [1.1, 0.9, 1.1] }}
        transition={{ duration: 4.5, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Logo — يظهر فقط إذا كان الشعار متاحاً، لا نص fallback */}
      {footerLogoUrl && (
        <motion.div
          className="flex items-center justify-center"
          initial={{ scale: 0.85, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.15, ease: 'easeOut' }}
        >
          <img
            src={footerLogoUrl}
            alt="شعار مشهد"
            style={{
              maxHeight: 76 * scaleRatio,
              maxWidth: 320 * scaleRatio,
              height: 'auto',
              width: 'auto',
            }}
            className="object-contain"
          />
        </motion.div>
      )}

      {/* Loading dots */}
      <motion.div
        className="absolute bottom-14 flex gap-2"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.9 }}
      >
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            className="rounded-full bg-white/35"
            style={{ width: 6, height: 6 }}
            animate={{ opacity: [0.25, 1, 0.25] }}
            transition={{ duration: 1.1, repeat: Infinity, delay: i * 0.22 }}
          />
        ))}
      </motion.div>
    </motion.div>
  );
};

export default SplashScreen;
